// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1rE1K","content":"RecentSearches_content__2YT3R"};